import { candleGeometry, elementAnchor } from "../../candle/candleModel";
import { COPY } from "./config";

// Concept explanations. Candle Anatomy teaches four concepts, each explained
// once, the first time it is missed (client: "Open/Close (one concept),
// High/Low (one concept), Body, Wick — each shown once"):
//
//   openClose  missed Open or Close   (copy follows the candle's colour)
//   highLow    missed High or Low
//   body       missed Body
//   wick       missed Wick
//
// The per-element correction line ("You marked… / Open belongs at…") is not
// repeated here; this is only the concept behind it.
export function explainCandleAnatomy(ohlc, zones, results) {
  if (results.allCorrect) return [COPY.explain.allCorrect];
  return explainMistakes(ohlc, results).map((m) => m.text);
}

export function explainMistakes(ohlc, results) {
  const r = results.byId;
  const g = candleGeometry(ohlc);
  const missed = (ids) => ids.some((id) => !r[id].correct);
  const list = [];
  if (missed(["open", "close"]))
    list.push({ key: "openClose", text: g.type === "red" ? COPY.explain.openCloseRed : COPY.explain.openCloseGreen });
  if (missed(["high", "low"])) list.push({ key: "highLow", text: COPY.explain.highLow });
  if (missed(["body"])) list.push({ key: "body", text: COPY.explain.body });
  if (missed(["wick"])) list.push({ key: "wick", text: COPY.explain.wick });
  return list;
}

// The positions each concept explanation points at, drawn as gold diamonds on
// the candle beside the explanation (client: "Words annotate the picture").
export function conceptMarkers(ohlc, key) {
  const g = candleGeometry(ohlc);
  const at = (id, label) => ({ id, label, point: elementAnchor(ohlc, id) });
  switch (key) {
    case "openClose":
      return [at("open", "Open"), at("close", "Close")];
    case "highLow":
      return [at("high", "High"), at("low", "Low")];
    case "body":
      return [at("body", "Body")];
    case "wick": {
      // Every visible wick, not just the longer one.
      const list = [];
      if (g.hasUpperWick) list.push({ id: "upperWick", label: "Wick", point: { x: 0, y: (ohlc.high + g.bodyTop) / 2 } });
      if (g.hasLowerWick) list.push({ id: "lowerWick", label: "Wick", point: { x: 0, y: (ohlc.low + g.bodyBottom) / 2 } });
      return list;
    }
    default:
      return [];
  }
}
